import Button from "../../../../components/button/button";
import { useState, useEffect } from "react";
import { useTodos } from "../../../../hooks/useTodos";
import { useCustomerContext } from "../../../../utils/customerContext";
import CreateTodo from "../components/createTodo";

function CuDeTodo({ id }) {
    const [createTodo, setCreateTodo] = useState(false);
    const [showCompletedTodos, setShowCompletedTodos] = useState(false);
    const { todos, deleteTodo, fetchTodos, updateTodo } = useTodos();
    const { fetchCustomerSlug } = useCustomerContext();

    useEffect(() => {
        fetchCustomerSlug(id);
        fetchTodos(id)
    }, [id, fetchCustomerSlug, fetchTodos]);

    const handleToggleTodo = async (todoId, isDone) => {
        await updateTodo(todoId, { done: isDone });
    };

    const visibleTodos = showCompletedTodos
        ? todos
        : todos.filter((todo) => !todo.done);

    return (
    <div className="cudeContentContainer">
        <div className="cudeHeadingContainer">
            <h3>Anstehende Todos</h3>
        </div>
        {createTodo && <CreateTodo onClose={() => setCreateTodo(false)} />}
        {visibleTodos.length === 0 ? (
            <div className="cudeCard">
                <p>{showCompletedTodos ? 'Keine erledigten Todos vorhanden' : 'Keine offenen Todos vorhanden'}</p>
            </div>
        ) : (
            visibleTodos.map((todo) => (
                <div key={todo._id} className="cudeCard">
                    <input
                        type="checkbox"
                        checked={todo.done || false}
                        onChange={() => handleToggleTodo(todo._id, !todo.done)}
                        style={{width: '20px', height: '20px'}}
                    />
                    <p><strong>Erstellt am:</strong> {todo.createdAt}</p>
                    <p><strong>Frist:</strong> {todo.formattedDate}</p>
                    <p><strong>Priorität:</strong> {todo.prio}</p>
                    <p><strong>Todo:</strong> {todo.description}</p>
                    <button onClick={() => deleteTodo(todo._id)}>
                        Todo löschen
                    </button>
                </div>
            ))
        )}
        <Button buttonType='button' buttonValue='Neue Todo' onClick={() => setCreateTodo(true)} />
        {todos.some((todo) => todo.done) && (
            <Button
                buttonType='button'
                buttonValue={showCompletedTodos ? 'Erledigte Todos ausblenden' : 'Erledigte Todos anzeigen'}
                onClick={() => setShowCompletedTodos((prev) => !prev)}
            />
        )}
    </div>
    );  
}

export default CuDeTodo;